import React from "react";
import ServiceBox from "./ServiceBox";
import {Col, Container, Row} from "reactstrap";
import { IOpportunitiesSection } from "../../Interfaces/shared";


const WhyOpportunitiesSection = ({title, image, services, altText }: IOpportunitiesSection) => {
  return(<section className="why-opportunities-section">
    <Container>
      <div className='section-title'>{title}</div>
      <Row>
        <Col md={12} xl={6} className="text-right">
          <img className="section-image" src={image} alt={altText} />
        </Col>
        <Col md={12} xl={6}>
          <div className="d-flex flex-wrap">
            {services?.map((service, index) => <div className="col-6" key={index}>
              <ServiceBox description={service.description} title={service.title} icon={service.icon} />
            </div>)}
          </div>
        </Col>
      </Row>
    </Container>
  </section>)
}

export default WhyOpportunitiesSection;